"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.relativeDateTimePresets = exports.relativeUnitValuesFuture = exports.relativeUnitValuesPast = void 0;
const createDateTimePresets = (presets) => {
    return Object.keys(presets).reduce((obj, key) => ({ ...obj, [key]: { id: key, ...presets[key] } }), {});
};
const relativeDateTimePresetsMinutes = createDateTimePresets({
    last15Minutes: { start: "now - 15 minutes", end: "now" },
    last30Minutes: { start: "now - 30 minutes", end: "now" },
    last60Minutes: { start: "now - 60 minutes", end: "now" },
});
const relativeDateTimePresetsHours = createDateTimePresets({
    lastHour: { start: "now - 1 hour", end: "now" },
    last12Hours: { start: "now - 12 hours", end: "now" },
    last24Hours: { start: "now - 24 hours", end: "now" },
});
const relativeDateTimePresetsDays = createDateTimePresets({
    lastDay: { start: "now - 1 day", end: "now" },
    last7Days: { start: "now - 7 days", end: "now" },
    last30Days: { start: "now - 30 days", end: "now" },
    previousDay: { start: "startOfDay - 1 day", end: "now" },
});
const relativeDateTimePresetsWeeks = createDateTimePresets({
    lastWeek: { start: "now - 1 week", end: "now" },
    previousWeek: { start: "startOfWeek - 1 week", end: "now" },
});
const relativeDateTimePresetsMonths = createDateTimePresets({
    lastMonth: { start: "now - 1 month", end: "now" },
    last3Months: { start: "now - 3 months", end: "now" },
    last6Months: { start: "now - 6 months", end: "now" },
    previousMonth: { start: "startOfMonth - 1 month", end: "now" },
});
const relativeDateTimePresetsYears = createDateTimePresets({
    currentYear: { start: "startOfYear", end: "now" },
    lastYear: { start: "now - 1 year", end: "now" },
    previousYear: { start: "startOfYear -1 year", end: "now" },
    twoYearsAgo: { start: "startOfYear - 2 years", end: "now" },
    threeYearsAgo: { start: "startOfYear - 3 years", end: "now" },
});
const relativeDateTimePresetsQuarters = createDateTimePresets({
    previousQuarter: { start: "startOfQuarter - 1 Quarter", end: "now" },
    quarter2CurrentYear: { start: "startOfYear + 2 quarters", end: "startOfYear + 3 quarters" },
    quarter1CurrentYear: { start: "startOfYear", end: "startOfYear + 1 quarters" },
    quarter4PreviousYear: { start: "startOfYear - 1 quarter", end: "startOfYear" },
    quarter3PreviousYear: { start: "startOfYear - 2 quarters", end: "startOfYear - 1 quarters" },
    quarter2PreviousYear: { start: "startOfYear - 3 quarters", end: "startOfYear - 2 quarters" },
    quarter1PreviousYear: { start: "startOfYear - 4 quarters", end: "startOfYear - 3 quarters" },
    half1CurrentYear: { start: "startOfYear", end: "startOfYear + 6 months" },
    half2CurrentYear: { start: "startOfYear + 6 months", end: "now" },
    half1PreviousYear: { start: "startOfYear - 1 year", end: "startOfYear - 6 months" },
    half2PreviousYear: { start: "startOfYear - 1 year", end: "startOfYear" },
});
/**
 * The "-" in the value is important and is used to when converting between expression and relative inputs.
 */
exports.relativeUnitValuesPast = {
    secondsAgo: "-seconds",
    minutesAgo: "-minutes",
    hoursAgo: "-hours",
    daysAgo: "-days",
    weeksAgo: "-weeks",
    monthsAgo: "-months",
    yearsAgo: "-years",
    quartersAgo: "-quarters",
};
exports.relativeUnitValuesFuture = {
    secondsFromNow: "seconds",
    minutesFromNow: "minutes",
    hoursFromNow: "hours",
    daysFromNow: "days",
    weeksFromNow: "weeks",
    monthsFromNow: "months",
    yearsFromNow: "years",
    quartersFromNow: "quarters",
};
exports.relativeDateTimePresets = {
    ...relativeDateTimePresetsMinutes,
    ...relativeDateTimePresetsHours,
    ...relativeDateTimePresetsDays,
    ...relativeDateTimePresetsWeeks,
    ...relativeDateTimePresetsMonths,
    ...relativeDateTimePresetsYears,
    ...relativeDateTimePresetsQuarters,
};
